/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Replace_BodyInputs */



/**
* | output |
* | --- |
* | "The previous recording and its transcript are replaced. Your report stays as it is until you write it again." |
*
* @param {Meeting_Offline_Replace_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_replace_body = /** @type {((inputs?: Meeting_Offline_Replace_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Replace_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De vorige opname en het transcript worden vervangen. Je verslag blijft staan tot je het opnieuw maakt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement précédent et sa transcription sont remplacés. Votre compte rendu reste tel quel jusqu'à ce que vous le rédigiez à nouveau.")
	return /** @type {LocalizedString} */ ("The previous recording and its transcript are replaced. Your report stays as it is until you write it again.")
});